import { Parametro } from './../../model/parametro';
import { Organizador } from '../../model/asamblea';
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatPaginator} from '@angular/material/paginator';
import { MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { IntranetService } from '../../intranet.service';
import { AlertaService } from 'src/app/util/alerta.service';
import { BusquedaAsamblea } from '../../model/busqueda-asamblea';
import { AsambleaRow } from '../../model/asamblea-row';
import { UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { EstadoDialogComponent } from './estado-dialog/estado-dialog.component';

@Component({
  selector: 'sura-asamblea-bandeja',
  templateUrl: './asamblea-bandeja.component.html',
  styleUrls: ['./asamblea-bandeja.component.scss']
})
export class AsambleaBandejaComponent implements AfterViewInit {
  linkActive = '';
  newArrayAsamblea: AsambleaRow[] = [];
  dataSource = new MatTableDataSource<AsambleaRow>(this.newArrayAsamblea);
  displayedColumns: string[] = ['ASAMBLEA', 'FONDO', 'FECHA', 'ESTADO', 'OPCIONES'];
  listaEstados: Parametro[] = [];
  listaOrganizadores: Organizador[] = [];
  busqueda: BusquedaAsamblea = new BusquedaAsamblea();
  minDate: Date;
  maxDate: Date;
  busquedaForm = new UntypedFormGroup({
    idAsamblea: new UntypedFormControl(null, [Validators.pattern('[0-9]*'), this.validarNumero()]),
    idOrganizador: new UntypedFormControl(null),
    fechaRegistro: new UntypedFormControl(null),
    estado: new UntypedFormControl(null)
  });

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private router: Router,
              private intranetService: IntranetService,
              private alertaService: AlertaService,
              private dialog: MatDialog) {
    this.linkActive = this.router.url;
    this.listarEstado();
    this.minDate = new Date(new Date().getFullYear() - 10, 0, 1);
    this.maxDate = new Date();
    this.cargarCombos();
    this.listarAsamblea(this.busqueda);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  openDialogEstado(idAsamblea: number, estado: string) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.data = estado;
    const dialogRef = this.dialog.open(EstadoDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
        data => data && data.nuevoEstado ? this.editarEstado(idAsamblea, data.nuevoEstado) : false
    );
  }

  buscarAsambleas() {
    const busquedaAsamblea = new BusquedaAsamblea();
    const busquedaFormValue = this.busquedaForm.value;
    const idAsamblea = busquedaFormValue['idAsamblea'];
    const idOrganizador = busquedaFormValue['idOrganizador'];
    const fechaRegistro = busquedaFormValue['fechaRegistro'];
    const estado = busquedaFormValue['estado'];

    busquedaAsamblea.idAsamblea = idAsamblea === null || idAsamblea === '' ? 0 : idAsamblea;
    busquedaAsamblea.idOrganizador = idOrganizador === null || idOrganizador === '' ? 0 : idOrganizador;
    busquedaAsamblea.fechaRegistro = fechaRegistro === null || fechaRegistro === '' ? '' : fechaRegistro.format('DD/MM/YYYY');
    busquedaAsamblea.estado = estado === null || estado === '' ? '' : estado;
    this.listarAsamblea(busquedaAsamblea);
  }

  listarAsamblea(busqueda: BusquedaAsamblea) {
    this.intranetService.listarAsamblea(busqueda).then(resultado => {
      if (resultado instanceof Array) {
        this.newArrayAsamblea.splice(0, this.newArrayAsamblea.length);
        for (let i = 0; i < resultado.length; i++) {
          this.newArrayAsamblea.push(resultado[i]);
        }
        this.dataSource._updateChangeSubscription();
      }
    }).catch(error => {
      this.newArrayAsamblea.splice(0, this.newArrayAsamblea.length);
      this.dataSource._updateChangeSubscription();
    });
  }

  listarEstado() {
    this.agregarParametro('P', 'Pendiente');
    this.agregarParametro('C', 'Cargada');
    this.agregarParametro('I', 'Iniciada');
    this.agregarParametro('X', 'Cancelada');
    this.agregarParametro('F', 'Finalizada');
    this.agregarParametro('V', 'Validada');
    this.agregarParametro('R', 'Registro Pausado');
    this.agregarParametro('S', 'Votación Pausada');
  }

  agregarParametro(codigo: string, descripcion: string) {
    const parametro = new Parametro();
    parametro.codigo = codigo;
    parametro.descripcion = descripcion;
    this.listaEstados.push(parametro);
  }

  cargarCombos() {
    this.intranetService.listarOrganizadores().then(resultado => {
      if (resultado instanceof Array) {
        this.listaOrganizadores = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  obtenerEstado(estado: string) {
    return this.listaEstados.filter(parametro => parametro.codigo === estado)[0].descripcion;
  }

  validarNumero(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      return control.value !== null && control.value !== '' && isNaN(parseInt(control.value, 0))
        ? {'noEsNumero': {value: control.value}} : null;
    };
  }

  hasError(controlName: string) {
    return this.busquedaForm.controls[controlName].invalid;
  }

  deshabilitarBtn(btnName: string, estado: string) {
    if (btnName === 'Validar' || btnName === 'Cambiar' || btnName === 'Eliminar' || btnName === 'Editar') {
      if (estado === 'P' || estado === 'V') {
        return false;
      }
    }
    if (btnName === 'Cambiar' || btnName === 'Eliminar') {
      if (estado === 'C' || estado === 'V') {
        return false;
      }
    }
    if (btnName === 'Cambiar') {
      if (estado === 'I' || estado === 'R' || estado === 'S') {
        return false;
      }
    }
    return true;
  }

  editarEstado(idAsamblea: number, nuevoEstado: string) {
    this.intranetService.modificarEstadoAsamblea(idAsamblea, nuevoEstado).then(resultado => {
        for (let i = 0; i < this.newArrayAsamblea.length; i++) {
          if (this.newArrayAsamblea[i].idAsamblea === idAsamblea) {
            if (nuevoEstado === 'E') {
              this.newArrayAsamblea.splice(i, 1);
              break;
            } else {
              this.newArrayAsamblea[i].estado = nuevoEstado;
              break;
            }
          }
        }
        this.dataSource._updateChangeSubscription();
        this.alertaService.info(resultado['message']);
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  editarBloqueo(idAsamblea: number, nuevoBloqueo: string) {


    this.intranetService.modificarBloqueoAsamblea(idAsamblea, nuevoBloqueo).then(resultado => {
        for (let i = 0; i < this.newArrayAsamblea.length; i++) {
          if (this.newArrayAsamblea[i].idAsamblea === idAsamblea) {
              this.newArrayAsamblea[i].bloquearVoto = nuevoBloqueo;
              break;
          }
        }
        this.dataSource._updateChangeSubscription();
        this.alertaService.info(resultado['message']);
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

}
